<template>
    <!-- 对话框 -->
    <el-dialog title="三方账户流水" :visible.sync="show" :before-close="closeDialog" width="80%">
        <div style="width: 95%; margin: 0 auto">
            <div>
                <div class="handle-box-search">
                    <div class="handle-box">
                        <el-row class="head-search">
                            <el-col :span="12">
                                <span class="title">账本模式</span>
                                <el-select
                                  
                                    style="width: 370px"
                                    v-model="search_data_children.mode"
                                    placeholder="请选择"
                                    clearable
                               
                                    @keyup.enter.native="waterSearch"
                                >
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="收入" value="add"></el-option>
                                    <el-option label="支出" value="sub"></el-option>
                                    
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <span class="title">三方名称</span>
                                <el-select
                                    v-model="search_data_children.third_id"
                                    placeholder="请选择三方"
                                    @visible-change="sfVisibleChange"
                                    @change="sfChange"
                                    @keyup.enter.native="waterSearch"
                                    clearable
                                >
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in third" :key="item.third_id" :label="item.third_name" :value="item.third_id">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row class="head-search">
                            <el-col :span="24">
                                <span class="title"> 操作时间</span>
                                <el-date-picker
                                    v-model="search_time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="timeChange"
                                    @keyup.enter.native="waterSearch"
                                    style="margin-bottom: 20px; margin-right: 20px; width: 370px"
                                >
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </div>
                    <el-button @click="waterSearch">搜索</el-button>
                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                </div>
            </div>
          

        

            <!-- 表格 -->
            <el-table :data="tableData" max-height="500" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column prop="account_name" label="三方名称"> </el-table-column>

                <!-- <el-table-column prop="operation" label="账户操作"> </el-table-column> -->

                <el-table-column prop="amount" label="变动金额"> </el-table-column>

                <el-table-column prop="description" label="描述"> </el-table-column>

                <el-table-column prop="time.YmdHis" label="操作时间"> </el-table-column>

                <el-table-column prop="mode_name" label="账本模式"> </el-table-column>
                <el-table-column prop="record_code" label="关联订单"> </el-table-column>
            </el-table>

            <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data_children.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data_children.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data_children.count"
            >
            </el-pagination>
        </div>

            <div style="display: flex; justify-content: center">
                <el-button
                    type="primary"
                    :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'"
                    @click="toExport"
                    :disabled="progress_show"
                    >{{ progress_show ? '导出中...' : '导出' }}</el-button
                >

                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },

    watch: {
        isShow(newData, oldData) {
            _this.show = true;
         
            _this.waterSearch();
        }
    },
    data() {
        return {
            show: false,
            progress_show: false,
            third: '',

            excelData: [],

            excelHead: [],
            tableData: [],

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                third_id: '',
                fixed_array: '',
                mode: ''
            },
            result_data_children: [],
            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            search_time: '',
          

            
         

          
        };
    },
    created() {
        _this = this;
    },
    methods: {
       
        sfChange(val) {
            _this.search_data_children.third_id = val;
            _this.thirdAccountRecordLists();
        },
        sfVisibleChange(val) {
            if (val) {
                _this
                    .$post('/Cooperatewine/thirdAccountList')
                    .then((res) => {
                        _this.third = res.data;
                    })
                    .catch((err) => {});
            }
        },

        timeChange(val) {
         
            if (val != null) {
                _this.search_data_children.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data_children.fixed_array = '';
            }
        },
     
        toExport() {
            _this.search_data_children.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this.progress_show = true;
            _this
                .$post('/Cooperatewine/thirdAccountRecordLists', _this.search_data_children)
                .then((res) => {
                    if (this.$route.path == '/thirdAccount') {
                  
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            _this.excelData.push({
                                account_name: res.data.result[i].account_name,
                           
                                amount: res.data.result[i].amount,
                                description: res.data.result[i].description,
                                time: res.data.result[i].time.YmdHis,
                                mode_name: res.data.result[i].mode_name,
                                record_code: res.data.result[i].record_code
                            });
                        }

                        if (_this.search_data_children.page * _this.search_data_children.limit < res.data.count) {
                            _this.search_data_children.page = _this.search_data_children.page + 1;
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();
                            _this.search_data_children.page = 1;
                            // 清空数据
                            _this.excelData = [];
                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['三方名称',  '变动金额', '描述', '操作时间','账本模式','关联订单'];
            const filterVal = ['account_name', 'amount','description', 'time', 'mode_name', 'record_code'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '三方总流水导出');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        waterSearch() {
            _this.search_data_children.page = 1;

            _this.thirdAccountRecordLists();
        },

        thirdAccountRecordLists() {
            _this
                .$post('/Cooperatewine/thirdAccountRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.tableData = res.data.result;
                    _this.result_data_children = res.data;
                  
                })
                .catch((err) => {});
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.progress_show = false;
            _this.third = '';
            _this.search_time = '';
            _this.tableData = [];
            _this.result_data_children = [];       
            _this.search_data_children = {
                page: 1,
                limit: 10,
                third_id: '',
                fixed_array: '',
                mode: ''
            };
        },

       
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data_children.limit = val;

            //初始化列表
            _this.thirdAccountRecordLists();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.thirdAccountRecordLists();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.thirdAccountRecordLists();
        },
        // 刷新按钮
        refresh() {
          
            _this.progress_show = false;
            _this.third = '';
            _this.search_time = '';
            _this.tableData = [];
            _this.result_data_children = [];
            _this.all = {};
         
            _this.search_data_children = {
                page: 1,
                limit: 10,
                third_id: '',
                fixed_array: '',
                mode: ''
            };
            
            _this.thirdAccountRecordLists();
        },
    }
};
</script>

<style scoped>
.search_style {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.capital-title {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
}

.text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.text > span {
    margin-right: 10px;
}
.money-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}
.money {
    margin-left: 5px;
}
.orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
    border: 0 !important;
}
.el-date-range-picker__time-header {
    display: block;
}
</style>




